/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
import 'whatwg-fetch';
import apiAgent from 'superagent';
import { eventChannel, END } from 'redux-saga';
import * as _ from 'lodash';

function parseJSON(response) {
  if (response.status === 204 || response.status === 205) {
    return null;
  }
  return response.json();
}

function parseFile(response) {
  if (response.status === 204 || response.status === 205) {
    return null;
  }
  return response.blob();
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
async function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  if (response.status === 400 || response.status === 500) {
    const body = await response.json();
    const error = new Error(response.statusText);
    let message = null;
    if (body.message === 'The request is invalid.' && !!body.modelState) {
      const listError = Object.values(body.modelState).flatMap((x) => x);
      message = listError.length > 0 ? listError.join() : '';
    }
    error.response = response;
    error.message = message !== null ? message : body.error;
    throw error;
  }

  const error = new Error(response.statusText);
  error.response = response;
  error.message =
    'We apologize for the inconvenience, but an unexpected error has occurred. Please contact our technical support.';
  throw error;
}

function checkServerValidation(response) {
  if (response === null) {
    return null;
  }

  if (Object.prototype.hasOwnProperty.call(response, 'errors')) {
    const error = new Error(response.statusText);
    error.message = response.errors.toString();
    throw error;
  }

  return response;
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(url, options) {
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(checkServerValidation);
}

const reduxFileUpload = (url, headers, formData) => {
  const fileUpload = apiAgent.post(url);

  _.forEach(headers, (value, key) => {
    fileUpload.set(key, value);
  });
  // for (const k in headers || {}) {
  //   fileUpload.set(k, headers[k]);
  // }

  return eventChannel((emitter) => {
    fileUpload
      .send(formData)
      .on('progress', (e) => {
        emitter({ percent: e.percent });
      })
      .then(checkStatus)
      .then((res) => {
        emitter({ success: res });
        emitter(END);
      })
      .catch((err) => {
        emitter({ err });
        emitter(END);
      });
    // we need to return an object which allows the channel to unsubscribe the event.
    return () => {
      fileUpload.abort();
    };
  });
};

const requestDownload = (url, options) => fetch(url, options)
  .then(checkStatus)
  .then(parseFile)
  .then(checkServerValidation);

export { reduxFileUpload, requestDownload };




// WEBPACK FOOTER //
// ./app/utils/request.js